module.exports = __webpack_public_path__ + "static/img/card-white.e9dae134.svg";